import React from 'react';
import { useTEF } from 'src/tef/components/providers/TEFProvider';
import { cn } from 'src/tef/components/utils/cn';

interface UnorderedListProps {
  children: React.ReactNode;
  variant?: {
    style?: 'disc' | 'circle' | 'square' | 'none';
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  };
  className?: string;
}

const listStyles = {
  disc: 'list-disc',
  circle: 'list-circle',
  square: 'list-square',
  none: 'list-none',
};

const spacingSizes = {
  xs: 'space-y-0.5 pl-4',
  sm: 'space-y-1 pl-4',
  md: 'space-y-2 pl-5',
  lg: 'space-y-3 pl-6',
  xl: 'space-y-4 pl-7',
};

export default function UnorderedList({ children, variant = {}, className }: UnorderedListProps) {
  const tef = useTEF();
  const style = variant.style || 'disc';
  const size = variant.size || 'md';

  return <ul className={cn(listStyles[style], spacingSizes[size], tef.colors.foreground, className)}>{children}</ul>;
}

export { UnorderedList };
